import { WheelHistoryType } from 'components/Base/PopUps/components/WheelOfFortune/components/WheelStatistics/types';

export const WHEEL_TYPE_OPTIONS = Object.values(WheelHistoryType);
